<template>
    <div class="orders-container">
        <b-container>
            <b-row>
                <b-col cols="12" class="mb-4">
                    <h3>Ordenes</h3>
                </b-col> 
                <b-col md="3" class="mb-3">
                    <b-form-input id="input-11" v-model="filters.name.value" placeholder="Buscar" type="text"></b-form-input> 
                </b-col>
                <b-col md="3" offset-md="3" cols="6" class="mb-3">
                    <b-form-file
                        id="input-1"
                        v-model="excelfile"
                        placeholder="Selecciona un archivo"
                    ></b-form-file>
                </b-col>
                <b-col md="3" cols="6" class="mb-3">
                    <b-button v-on:click="importExcel">Importar</b-button>
                </b-col>
                <b-col cols="12">
                    <v-table
                        :data="orders"
                        :currentPage.sync="currentPage"
                        :pageSize="7"
                        :filters="filters"
                        @totalPagesChanged="totalPages = $event"
                        class="mb-3"
                    >
                        <thead slot="head">
                            <th>ID</th>
                            <th>Hospital</th>
                            <th>Sub Configuración de Puesto</th>
                            <th>Puesto</th>
                            <th>Nombre</th>
                            <th></th>
                        </thead>
                        <tbody slot="body" slot-scope="{displayData}">
                            <tr v-for="row in displayData" :key="row.guid">
                                <td>{{ row.id }}</td>
                                <td>{{ row.hospital.name }}</td>
                                <td>{{ row.area.name }}</td>
                                <td>{{ row.position.name }}</td>
                                <td>{{ row.name }} {{ row.first_lastname }} {{ row.second_lastname }}</td>
                                <td><router-link :to="{ name: 'EditOrder', params: { orderId: row.id}}" class="btn">Editar</router-link></td>
                            </tr>
                        </tbody>
                    </v-table>
                    <smart-pagination
                        :currentPage.sync="currentPage"
                        :totalPages="totalPages"
                    />
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
    import axios from 'axios'
    import qs from 'qs'

    export default {
        created (){
            var token = sessionStorage.getItem('api_token')
            var id_user = sessionStorage.getItem('id_user')
            var is_admin = sessionStorage.getItem('is_admin')
            if (is_admin != 'yes'){
                this.$router.push('/orden')
            }

            axios
            .post(
                process.env.VUE_APP_ROUTE_BACKEND_API+'orders_api.php',
                qs.stringify({ 
                    api_token: token, 
                    user_id: id_user,
                    option: 'get_orders'
                }),
            )
            .then((response) => {
                if (!response.data.error.code) {
                    let temp = []
                    Object.keys(response.data.orders).map((key) => [response.data.orders[key]]).map(function(value) {
                        temp.push(value[0])
                    })
                    this.orders = temp
                }
            })
            .catch((err) => {
                console.log(err)
            })
        },
        methods: {
            importExcel (){

            }
        },
        data() {
            return {
                orders: [],
                currentPage: 1,
                excelfile: '',
                totalPages: 0,
                filters: {
                    name: { value: '', keys: ['name', 'first_lastname', 'second_lastname', 'hospital.name', 'area.name', 'position.name' ] }
                }
            }
        }
    }
</script>

<style scoped>
.orders-container{
    padding: 70px 5%;
}
table{
    width: 100%;
}

.btn,
.btn:focus,
.btn:hover{
    background: #24A7DF;
    border: none;
    font-weight: normal;
    color: #fff;
}
h3{
    font-weight: bold;
    font-size: 25px;
}
</style>